import { COLORS } from 'src/theme/palette';
import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '512px',
    maxWidth: '100%',
    padding: 3,
  },
  title: {
    marginBottom: 3,
  },
  list: {
    listStyle: 'none',
    margin: '16px 0 0',
    padding: 0,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    padding: '12px 0',
    borderTop: `1px solid ${COLORS.black10}`,
    '&:last-of-type': {
      borderBottom: `1px solid ${COLORS.black10}`,
    },
  },
  // one width in every state, so the line does not move
  fileButton: {
    width: '136px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  buttons: {
    display: 'flex',
    marginTop: 4,
  },
  closeButton: {
    padding: '7px 48px',
  },
});

export default styles;
